import script from "./OfferStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./OfferStatus.vue?vue&type=script&setup=true&lang=js"

import "./OfferStatus.vue?vue&type=style&index=0&id=e31ab9aa&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e31ab9aa"]])

export default __exports__